import React, { Fragment, PureComponent } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Spacer, TextBoxPlaceholder } from '../Shimmer';

const ContactDetails = ({ contactList }) => {
  if (!contactList) return <TextBoxPlaceholder />;
  return contactList.map(contact => (
    <Fragment key={contact.phone}>
      <p key={contact.name}>
        <strong>
          {contact.name}
          {' '}
(
          {contact.phone}
)
        </strong>
      </p>
      <p key={contact.email}>{contact.email}</p>
    </Fragment>
  ));
};

const ProjectDetails = ({ summary }) => {
  if (!summary) {
    return (
      <Fragment>
        <Spacer size={40} />
        <TextBoxPlaceholder />
        <Spacer size={40} />
      </Fragment>
    );
  }
  const {
    newSummary: { name: newName, version: newVersion, summary: newSummary },
    oldSummary: { name: oldName, version: oldVersion, summary: oldSummary },
  } = summary;

  return (
    <Fragment>
      <Spacer size={40} />
      <Row>
        <Col md={4}>
          <div>
            <strong>Version Name:</strong>
            {' '}
            {newName}
          </div>
          <div>
            <strong>Version No:</strong>
            {' '}
            {newVersion}
          </div>
          <div>
            <strong>Total Quote Amount:</strong>
            {' '}
₹
            {newSummary.total.toLocaleString('en-IN')}
          </div>
        </Col>
        <Col md={4}>
          <div>
            <strong>Version Name:</strong>
            {' '}
            {oldName}
          </div>
          <div>
            <strong>Version No:</strong>
            {' '}
            {oldVersion}
          </div>
          <div>
            <strong>Total Quote Amount:</strong>
            {' '}
₹
            {oldSummary.total.toLocaleString('en-IN')}
          </div>
        </Col>
      </Row>
      <Spacer size={40} />
    </Fragment>
  );
};

const ClientDetail = ({ responseModel }) => (
  <Fragment>
    <Spacer size={20} />
    <div id="client_detail">
      <p
        style={{
          borderBottom: '1px solid black',
          fontWeight: 'bold',
          fontSize: '13px',
        }}
        className="add_orange_color"
      >
        Customer
      </p>
      {responseModel
      && responseModel.welcomeScreen
      && responseModel.welcomeScreen.customerId ? (
        <Fragment>
          <span
            style={{
              fontSize: 15,
              fontWeight: 'bold',
            }}
          >
            {responseModel.welcomeScreen.customerName}
          </span>
          <p
            style={{
              marginTop: 10,
              fontSize: 13,
            }}
          >
            <strong>Customer ID</strong>
:
            {' '}
            {responseModel.welcomeScreen.customerId}
          </p>
          <p
            style={{
              marginBottom: 5,
              fontSize: 13,
            }}
          >
            <strong>Quote Version</strong>
:
            {' '}
            {responseModel.welcomeScreen.priceVersion}
          </p>
        </Fragment>
        ) : (
          <TextBoxPlaceholder />
        )}
    </div>
  </Fragment>
);

export default class WelcomeScreen extends PureComponent {
  render() {
    const { customerData, summary } = this.props;
    const {
      clientId,
      name,
      salesAgents,
      priceVersion,
      designerEmail,
      designerName,
      designerPhone,
    } = customerData || {};
    const designerDetails = designerName && [
      {
        name: designerName,
        email: designerEmail,
        phone: designerPhone,
      },
    ];
    const responseModel = {
      welcomeScreen: {
        customerId: clientId,
        customerName: name,
        priceVersion,
      },
    };

    return (
      <Container>
        <div className="row">
          <div className="col-md-12">
            <div id="logowrapper">
              <div id="homelane_logo">
                <a
                  href="//www.homelane.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="//d7gpgy8svgdhy.cloudfront.net/0.0.15/images/rsz_hl_logo4.png"
                    alt="Homelane Logo"
                  />
                </a>
              </div>
              <div id="city_wrapper">
                <ul id="city_dropdown">
                  <li>Bengaluru</li>
                  <li>Chennai</li>
                  <li>Hyderabad</li>
                  <li>Mumbai</li>
                  <li>Delhi NCR</li>
                </ul>
                <span
                  style={{
                    float: 'left',
                    textAlign: 'right',
                    fontSize: '11px',
                    fontWeight: 400,
                  }}
                >
                  <strong>
                    <a
                      href="//www.homelane.com/"
                      style={{
                        color: 'black',
                        textDecoration: 'block',
                      }}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      www.homelane.com
                    </a>
                  </strong>
                </span>
              </div>
            </div>
            <div id="title">
              <h3>Quote Compare</h3>
            </div>
            <div className="accent">
              <div id="orange" />
              <div id="red" />
            </div>

            <ProjectDetails summary={summary} />

            <ClientDetail responseModel={responseModel} />
            <div id="designer_details">
              <div className="contactus_box">
                <p
                  className="add_orange_color"
                  style={{
                    borderBottom: '1px solid black',
                    padding: 5,
                  }}
                >
                  <strong className="add_orange_color">Designer</strong>
                </p>
                <ContactDetails contactList={designerDetails} />
              </div>
              <div
                className="contactus_box"
                style={{
                  float: 'right',
                }}
              >
                <p
                  className="add_orange_color"
                  style={{
                    borderBottom: '1px solid black',
                    padding: 5,
                  }}
                >
                  <strong className="add_orange_color">Sales Manager</strong>
                </p>
                <ContactDetails contactList={salesAgents} />
              </div>
            </div>
            <div
              className="row"
              style={{
                marginTop: 215,
              }}
            >
              <div className="col-md-3">
                <div className="usp_wrapper">
                  <div className="image_wrapper">
                    <img
                      src="//s3-ap-southeast-1.amazonaws.com/hlmicrosite/45+day%402x.png"
                      alt="usp1"
                    />
                  </div>
                  <p>45-Day Installation Guarantee</p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="usp_wrapper">
                  <div className="image_wrapper">
                    <img
                      src="//s3-ap-southeast-1.amazonaws.com/hlmicrosite/5+Year+Warranty%402x.png"
                      alt="usp2"
                    />
                  </div>
                  <p>5-Year Warranty</p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="usp_wrapper">
                  <div className="image_wrapper">
                    <img
                      src="//s3-ap-southeast-1.amazonaws.com/hlmicrosite/2500%2B%402x.png"
                      alt="usp3"
                    />
                  </div>
                  <p>2500+ Happy Customers</p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="usp_wrapper">
                  <div className="image_wrapper">
                    <img
                      src="//s3-ap-southeast-1.amazonaws.com/hlmicrosite/Post-Installation%402x.png"
                      alt="usp4"
                    />
                  </div>
                  <p>Post-Installation Care</p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 footer_contact">
                {/* border-bottom: 2px solid #f6f6f6; padding-bottom: 15px; */}
                <p
                  style={{
                    borderBottom: '2px solid #f6f6f6',
                    paddingBottom: 15,
                  }}
                >
                  <strong>Need any help?</strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;In case of any queries,
                  reach us at our Toll Free Number : 1800 - 102 - 4663
                </p>
              </div>
            </div>
          </div>
        </div>
      </Container>
    );
  }
}

// ContactDetails.propTypes = {
//   contactList: PropTypes.arrayOf({
//     phone: PropTypes.string,
//     name: PropTypes.string,
//     email: PropTypes.string,
//   }),
// };

// ProjectDetails.propTypes = {
//   summary: PropTypes.object,
// };

// ClientDetail.propTypes = {
//   responseModel: {
//     welcomeScreen: PropTypes.shape({
//       customerId: PropTypes.string,
//       customerName: PropTypes.string,
//       priceVersion: PropTypes.string,
//     }),
//   },
// };

// WelcomeScreen.propTypes = {
//   customerData: PropTypes.object,
//   summary: PropTypes.object,
// };

// ContactDetails.defaultProps = {
//   contactList: [],
// };

// ProjectDetails.defaultProps = {
//   summary: {},
// };

// ClientDetail.defaultProps = {
//   responseModel: {
//     welcomeScreen: {
//       customerId: '',
//       customerName: '',
//       priceVersion: '',
//     },
//   },
// };

// WelcomeScreen.defaultProps = {
//   customerData: {},
//   summary: {},
// };



// WEBPACK FOOTER //
// ./src/components/WelcomeScreen/index.js